import axios from "axios";

// ============================================================
// API CLIENT CONFIGURATIE
// ============================================================
// Development: http://localhost:5254/api
// Production: https://api.dowhatyouwant.be/api
// ============================================================

const getBaseURL = () => {
  const isDevelopment = process.env.NODE_ENV === 'development';

  if (isDevelopment) {
    return "http://localhost:5254/api";
  } else {
    return "https://api.dowhatyouwant.be/api";
  }
};

const api = axios.create({
    baseURL: getBaseURL(),
    headers: {
        "Content-Type": "application/json"
    }
});

// Log de API URL in development
if (process.env.NODE_ENV === 'development') {
  console.log(`🔗 API connected to: ${getBaseURL()}`);
}

export default api;
